document.querySelectorAll('.js-prod-qty').forEach(btn => {
  btn.addEventListener('click', () => {
    const qtyInput = btn.closest('.qty-selector')?.querySelector('input.quantity');
    if (!qtyInput) return;

    const currValue = parseInt(qtyInput.value, 10) || 0;
    const dir = btn.dataset.direction === '+' ? 1 : -1;
    qtyInput.value = Math.max(1, currValue + dir);
  });
});



// Packaging checkbox: show it from 2 oz up, fill in [QTY], and keep the tick when the theme reloads it.
(() => {
  const scopeOf = (el) => el.closest('.shopify-section') || document;

  const syncPackaging = (scope) => {
    const option = scope.querySelector('[data-packaging-option]');
    if (!option) return;

    const container = option.closest('.packaging-blocks');
    const checkbox = option.querySelector('input[type="checkbox"]');
    const qtyInput = scope.querySelector('input.quantity');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    const multiple = qty >= 2;

    option.classList.toggle('is-visible', multiple);
    if (!multiple) {
      checkbox.checked = false;
      container.dataset.packagingChecked = 'false';
    } else if (container.dataset.packagingChecked === 'true') {
      checkbox.checked = true;
    }

    option.querySelectorAll('[data-packaging-qty]').forEach(el => {
      el.textContent = multiple ? String(qty) : '';
    });
  };

  const syncAll = () => {
    document.querySelectorAll('.packaging-blocks').forEach(container => {
      const checkbox = container.querySelector('[data-packaging-option] input[type="checkbox"]');
      if (checkbox && checkbox.checked) container.dataset.packagingChecked = 'true';
      syncPackaging(scopeOf(container));
    });
  };

  document.addEventListener('input', e => {
    if (e.target.matches('input.quantity')) syncPackaging(scopeOf(e.target));
  });

  document.addEventListener('change', e => {
    if (e.target.matches('input.quantity')) syncPackaging(scopeOf(e.target));
    if (e.target.matches('[data-packaging-option] input[type="checkbox"]')) {
      e.target.closest('.packaging-blocks').dataset.packagingChecked = e.target.checked ? 'true' : 'false';
    }
  });

  // Runs after the +/- button's own click handler has changed the number.
  document.addEventListener('click', e => {
    const btn = e.target.closest('.js-prod-qty');
    if (btn) syncPackaging(scopeOf(btn));
  });

  // Switching variants replaces the packaging markup with a fresh copy.
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => syncPackaging(scopeOf(m.target)));
  });

  const start = () => {
    document.querySelectorAll('.packaging-blocks').forEach(container => {
      observer.observe(container, { childList: true });
    });
    syncAll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Back/forward can restore an old page state.
  window.addEventListener('pageshow', syncAll);
})();
